<template>
  <article class="form_modal">
    <section class="contact_form">
      <div class="contact_form__form_container">
        <p class="contact_form__title"
          v-html="'Contáctenos'"></p>
        <div class="contact_form__input_section fullwidth">
          <label
            for="user"
            class="form_modal__label"
            v-html="'Nombre'"></label>
          <input type="text" name="name" v-model="data.user" class="form_modal__input">
        </div>
        <div class="contact_form__input_section">
          <div class="contact_form__input_subsection">
            <label
              for="phone"
              class="form_modal__label"
              v-html="'Teléfono'"></label>
            <input type="phone" name="phone" v-model="data.phone" class="form_modal__input">
          </div>
          <div class="contact_form__input_subsection">
            <label
              for="email"
              class="form_modal__label"
              v-html="'Correo electrónico'"></label>
            <input type="email" name="email" v-model="data.email" class="form_modal__input">
          </div>
        </div>
        <div class="contact_form__input_section fullwidth">
          <label
            for="comments"
            class="form_modal__label"
            v-html="'¿En que podemos ayudarte?'"></label>
          <textarea
            rows="6"
            v-model="data.comment">
          </textarea>
        </div>
        <div class="contact_form__checkout">
          <button
            type="button"
            class="contact_form__checkout--button"
            @click="submit()"
            v-html="'Enviar'"></button>
        </div>
        <app-close-icon class="form_modal__close" ></app-close-icon>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      data: {
        user: '',
        phone: null,
        email: '',
        comment: ''
      }
    }
  },
  methods:{
    submit(){
      this.$http.post('contact_email', { data:this.data} )
      .then(response => {
        this.updateContactModal(false);
      }, error => {
        alert('No se pudo enviar la información');
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/ContactModal.vue